(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-complementary');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations-complementary');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // src/utils/recently-viewed-global.js
  (function () {
    const recentlyViewedKey = 'recently_viewed_handles';
    const maxItems = 10;
    const currentLocale = window.product?.locale || document.documentElement.lang.toLowerCase();

    function getProductHandle() {
      if (window?.meta?.product?.handle) return window.meta.product.handle;
      if (window?.Shopify?.product?.handle) return window.Shopify.product.handle;
      const metaHandle = document.querySelector('meta[name="product-handle"]');
      if (metaHandle) return metaHandle.getAttribute('content');
      if (document.body.dataset.productHandle) return document.body.dataset.productHandle;
      return null;
    }

    function saveHandle(handle) {
      let items = [];
      try {
        const stored = JSON.parse(localStorage.getItem(recentlyViewedKey));
        // Handle both old format (array of strings) and new format (array of objects)
        items = Array.isArray(stored)
          ? stored.map((h) => (typeof h === 'string' ? { handle: h, locale: currentLocale } : h))
          : [];
      } catch {}

      // Remove this handle from the list if it exists
      items = items.filter((item) => !(item.handle === handle));

      // Add the new handle at the start
      items.unshift({ handle, locale: currentLocale });

      // Keep only the maximum number of items
      if (items.length > maxItems) items = items.slice(0, maxItems);

      localStorage.setItem(recentlyViewedKey, JSON.stringify(items));
    }

    const handle = getProductHandle();
    if (handle) saveHandle(handle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
